import { render } from "./3d-baij.vue?vue&type=template&id=f21c6b86&scoped=true"
import script from "./3d-baij.vue?vue&type=script&lang=js"
export * from "./3d-baij.vue?vue&type=script&lang=js"

import "./3d-baij.vue?vue&type=style&index=0&id=f21c6b86&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f21c6b86"]])

export default __exports__